import { Signal } from "signals";
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";

export abstract class MenuSection {

    public closeSignal: Signal;

    protected options: object;
    protected signal: Signal;
    protected layer: Layers;

    private closeCover: PIXI.Sprite;
    private background: PIXI.Sprite;

    constructor(signal: Signal, initialValues: object, layer: Layers = Layers.MenusContent) {
        this.signal = signal;
        this.options = initialValues;
        this.layer = layer;

        this.closeSignal = new Signal();

        this.setupCloseCover();
        this.setupBackgroundBlocker();
    }

    public destroy() {
        if (this.closeCover) {
            this.closeCover.interactive = false;
            this.closeCover.off(ButtonEvent.POINTER_DOWN.getEventString(), this.close);
        }

        if (this.background) {
            this.background.interactive = false;
        }

        this.closeSignal.removeAll();
        this.closeSignal = null;

        this.signal = null;
        this.options = null;
    }

    protected close = () => {
        this.closeSignal.dispatch();
    }

    protected sendOptions() {
        this.signal.dispatch(this.options);
    }

    protected setupCloseCover() {
        this.closeCover = this.layer.getSprite("cover");
        if (this.closeCover) {
            this.closeCover.interactive = true;
            this.closeCover.off(ButtonEvent.POINTER_DOWN.getEventString(), this.close);
            this.closeCover.on(ButtonEvent.POINTER_DOWN.getEventString(), this.close);
        }
    }

    protected setupBackgroundBlocker() {
        this.background = this.layer.getSprite("background");
        if (this.background) {
            this.background.interactive = true;
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/components/betbar/menus/menu-section.ts